import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let images = gsap.utils.toArray('.ScrollSlidesImages__single');
let contents = gsap.utils.toArray('.ScrollSlidesContent__single');
let numSlides = images.length;

let menuHeight = document.querySelector('header.Header').offsetHeight;

const scrollSlides = document.querySelector('.ScrollSlides');

if (scrollSlides) {
    // Ustaw wysokość .ScrollSlides dynamicznie, odejmując wysokość menu
    scrollSlides.style.height = `calc(100vh - ${menuHeight}px)`;
  }

let scrollTl = gsap.timeline({
    scrollTrigger: {
        trigger: '.ScrollSlides',
        start: `bottom bottom`, // Rozpocznij animację po uwzględnieniu wysokości menu
        end: '+=' + (window.innerHeight * (numSlides + 0.8)),
        scrub: 0.5,
        pin: '.ScrollSlides', // Pinowanie samej sekcji
        pinSpacing: true, // Ustalamy, żeby pin nie dodawał dodatkowej przestrzeni
        // markers: true,
    },
});

// Animacje dla obrazków
images.forEach((img, i) => {
    let position = i * 1.9; // Zwiększamy odstępy między animacjami, tak samo jak dla contentu
    if (i === 0) {
        scrollTl.fromTo(img, 
            { yPercent: 0, zIndex: numSlides + i },
            { yPercent: 0, duration: 1 },
            position
        );
    } else {
        scrollTl.fromTo(img, 
            { yPercent: 100, zIndex: numSlides + i },
            { yPercent: 0, duration: 1 },
            position
        );
    }
});

// Animacje dla contentu
contents.forEach((content, i) => {
    const zIndex = numSlides - i;
    const position = i * 2; 
    
    // Wjeżdżanie contentu
    if (i === 0) {
        scrollTl.fromTo(content,
            { y: '20%', opacity: 0, zIndex: zIndex },
            { y: '0%', duration: 1, opacity: 1, zIndex: zIndex },
            position
        );
    } else {
        scrollTl.fromTo(content,
            { x: '-100%', opacity: 1, zIndex: zIndex },
            { x: '0%', duration: 1, opacity: 1, zIndex: zIndex },
            position
        );
    }

    // Pauza - podkreślenie obecności contentu
    scrollTl.to(content, {
        duration: 0.5,
        ease: "none",
        onStart: () => {
            // Możesz dodać efekt podkreślenia, np.:
            content.classList.add('active');
        },
        onReverseComplete: () => {
            content.classList.remove('active');
        }
    }, position + 1);
    
    // Wyjeżdżanie contentu (oprócz ostatniego)
    if (i !== contents.length - 1) {
        scrollTl.to(content,
            { 
                x: '100%', 
                duration: 1,
                onStart: () => {
                    content.classList.remove('active');
                }
            },
            position + 1.5
        );
    }
});
